import { AuthStorage } from "utils/auth-storage";
import { Button, Drawer, Select, Tag } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import {
  FilePdfOutlined,
} from "@ant-design/icons";
import { toast } from "react-hot-toast";
import { useParams } from "react-router-dom";
import { DistributionServices } from "apis/Services/DistributionService";
import { ContactServices } from "apis/Services/ContactService";
import { PermissionServices } from "apis/Services/PermissionsService";

function SidebarDistribution({
  isLoading,
  reportName,
  reportOwner,
  SelectViewOptions,
  isProcLog = false,
  isWarehouseReport = false,
  disabledButton = false,
}) {
  let code = AuthStorage.getItem("token");
  let email = AuthStorage.getItem("email");

  const { company_id, id } = useParams();

  const [open, setOpen] = useState(false);
  const [contact, setContact] = useState(null);

  // Distribute Now section state
  const [nowRecipients, setNowRecipients] = useState([]);
  const [nowSendAs, setNowSendAs] = useState(isProcLog ? "pdf" : null);

  // Schedule Distribute section state
  const [scheduleRecipients, setScheduleRecipients] = useState([]);
  const [scheduleSaveAs, setScheduleSaveAs] = useState(
    isProcLog ? "pdf" : null
  );
  const [frequency, setFrequency] = useState(null);
  const [weekDays, setWeekDays] = useState("");
  const [monthlyDay, setMonthlyDay] = useState(null);
  const [scheduleTime, setScheduleTime] = useState(null);
  const [timezone, setTimezone] = useState(null);
  const [Loading, setloading] = useState(true);
  const [mode, setMode] = useState("");

  // Distribute  view
  const [nowView, setNowView] = useState("Koncurent Standard View");
  const [scheduleView, setScheduleView] = useState("Koncurent Standard View");

  const [koncurentStatus, setKoncurentStatus] = useState([]);

  // Distribute Now status
  const [nowStatusFilter, setNowStatusFilter] = useState([]);

  // Original values for change tracking
  const [originalScheduleData, setOriginalScheduleData] = useState({
    recipients: [],
    koncurentStatus: [],
    saveAs: null,
    frequency: null,
    weekDays: [],
    monthlyDay: null,
    time: null,
    timezone: null,
    view: null,
  });

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const normalizeListValue = (value) => {
    if (Array.isArray(value)) {
      return value.filter(Boolean);
    }

    if (typeof value === "string") {
      return value
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean);
    }

    return [];
  };

  const getBaseRequestData = useCallback(
    (overrides = {}) => ({
      code,
      loginEmail: email,
      company: company_id,
      ...(isWarehouseReport ? {} : { project: id }),
      reportName,
      reportOwner,
      ...overrides,
    }),
    [code, company_id, email, id, isWarehouseReport, reportName, reportOwner],
  );

  const getContacts = useCallback(() => {
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");

    const request = isWarehouseReport
      ? PermissionServices.readCompanyContactsTemplate({
          company_id,
          code,
          loginEmail: email,
        })
      : ContactServices.getProjectsContactPage({
          company_id,
          id,
          code,
          loginEmail: email,
        });

    request
      .then((res) => {
        setContact(
          isWarehouseReport ? { content: res?.content || {} } : res,
        );
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {});
  }, [company_id, id, isWarehouseReport]);

  useEffect(() => {
    getContacts();
  }, [getContacts]);

  const userOptions = Object.entries(contact?.content || {})
    .flatMap(([company, contacts]) =>
      contacts.map((c) => ({
        label: `${c["First Name"]} ${c["Last Name"]}`,
        value: c["Email Address"],
        searchText:
          `${c["First Name"]} ${c["Last Name"]} ${c["Email Address"]}`.toLowerCase(),
        firstName: c["First Name"], // keep for sorting
      }))
    )
    .sort((a, b) => a.firstName.localeCompare(b.firstName));

  const sendAsOptions = [
    { label: "PDF", value: "pdf" },
    { label: "CSV", value: "csv" },
  ];

  const frequencyOptions = [
    { label: "Daily", value: "Daily" },
    { label: "Daily (Weekdays Only)", value: "Daily-WeekDaysOnly" },
    { label: "Weekly", value: "weekly" },
    { label: "Monthly", value: "monthly" },
  ];

  const weekDayOptions = [
    { label: "Monday", value: "Monday" },
    { label: "Tuesday", value: "Tuesday" },
    { label: "Wednesday", value: "Wednesday" },
    { label: "Thursday", value: "Thursday" },
    { label: "Friday", value: "Friday" },
    { label: "Saturday", value: "Saturday" },
    { label: "Sunday", value: "Sunday" },
  ];

  const timeOptions = [
    { label: "12:00 AM", value: "0" },
    { label: "1:00 AM", value: "1" },
    { label: "2:00 AM", value: "2" },
    { label: "3:00 AM", value: "3" },
    { label: "4:00 AM", value: "4" },
    { label: "5:00 AM", value: "5" },
    { label: "6:00 AM", value: "6" },
    { label: "7:00 AM", value: "7" },
    { label: "8:00 AM", value: "8" },
    { label: "9:00 AM", value: "9" },
    { label: "10:00 AM", value: "10" },
    { label: "11:00 AM", value: "11" },
    { label: "12:00 PM", value: "12" },
    { label: "1:00 PM", value: "13" },
    { label: "2:00 PM", value: "14" },
    { label: "3:00 PM", value: "15" },
    { label: "4:00 PM", value: "16" },
    { label: "5:00 PM", value: "17" },
    { label: "6:00 PM", value: "18" },
    { label: "7:00 PM", value: "19" },
    { label: "8:00 PM", value: "20" },
    { label: "9:00 PM", value: "21" },
    { label: "10:00 PM", value: "22" },
    { label: "11:00 PM", value: "23" },
  ];

  const timezoneOptions = [
    { label: "UTC (Coordinated Universal Time)", value: "UTC" },
    { label: "EST (Eastern Standard Time)", value: "America/New_York" },
    { label: "CST (Central Standard Time)", value: "America/Chicago" },
    { label: "MST (Mountain Standard Time)", value: "America/Denver" },
    { label: "PST (Pacific Standard Time)", value: "America/Los_Angeles" },
    { label: "GMT (Greenwich Mean Time)", value: "Europe/London" },
    { label: "CET (Central European Time)", value: "Europe/Paris" },
    { label: "JST (Japan Standard Time)", value: "Asia/Tokyo" },
    {
      label: "AEST (Australian Eastern Standard Time)",
      value: "Australia/Sydney",
    },
    { label: "IST (India Standard Time)", value: "Asia/Kolkata" },
    { label: "CST (China Standard Time)", value: "Asia/Shanghai" },
  ];

  const monthlyDayOptions = Array.from({ length: 28 }, (_, i) => ({
    label: `${i + 1}`,
    value: i + 1,
  }));

  const handleFrequencyChange = (value) => {
    setFrequency(value);
    // Reset dependent fields when frequency changes
    setWeekDays("");
    setMonthlyDay(null);
  };

  // Helper function to compare arrays
  const arraysEqual = (a, b) => {
    if (a.length !== b.length) return false;
    return a.every((val, index) => val === b[index]);
  };

  // Check if there are changes in schedule distribution data
  const hasScheduleChanges = () => {
    if (mode !== "update") return false;

    return (
      !arraysEqual(
        [...scheduleRecipients].sort(),
        [...originalScheduleData.recipients].sort()
      ) ||
      !arraysEqual(
        [...koncurentStatus].sort(),
        [...originalScheduleData.koncurentStatus].sort()
      ) ||
      scheduleSaveAs !== originalScheduleData.saveAs ||
      frequency !== originalScheduleData.frequency ||
      weekDays !== originalScheduleData.weekDays ||
      monthlyDay !== originalScheduleData.monthlyDay ||
      scheduleTime !== originalScheduleData.time ||
      scheduleView !== originalScheduleData.view ||
      timezone !== originalScheduleData.timezone
    );
  };

  // Reset functions
  const resetDistributeNow = () => {
    setNowRecipients([]);
    setNowSendAs(isProcLog ? "pdf" : null);
    setNowStatusFilter([]);
    setNowView("Koncurent Standard View");
  };

  const resetScheduleDistribute = useCallback(() => {
    setScheduleRecipients([]);
    setKoncurentStatus([]);
    setScheduleSaveAs(isProcLog ? "pdf" : null);
    setFrequency(null);
    setWeekDays("");
    setMonthlyDay(null);
    setScheduleTime(null);
    setTimezone(null);
    setScheduleView("Koncurent Standard View");
  }, [isProcLog]);

  // Check if sections have data
  const hasDistributeNowData = nowRecipients.length > 0 || nowSendAs;
  const hasScheduleDistributeData =
    scheduleRecipients.length > 0 ||
    koncurentStatus.length > 0 ||
    scheduleSaveAs ||
    frequency ||
    weekDays ||
    monthlyDay ||
    scheduleTime ||
    timezone;

  const sendOutReportsEmails = (data) => {
    setloading(true);
    const toastId = toast.loading("Distributing Report");
    const request = isWarehouseReport
      ? DistributionServices.sendOutWarehouseReportsEmails(data)
      : DistributionServices.sendOutReportsEmails(data);

    request
      .then((res) => {
        toast.success("Report Distributed successfully", { id: toastId });
        resetDistributeNow();
        setloading(false);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong, please try again.", {
          id: toastId,
        });
        setloading(false);
      });
  };

  const handleDistributeNow = () => {
    let data = getBaseRequestData({
      csvFormat: nowSendAs === "csv" ? "1" : "0",
      pdfFormat: nowSendAs === "pdf" ? "1" : "0",
      recipientsEmails: nowRecipients.join(","),
      ...(!isWarehouseReport
        ? {
            pdfStatusFilter: nowStatusFilter.join(","),
            pdfLastUsedView: nowView || "Koncurent Standard View",
          }
        : {}),
    });

    console.log("Distribute Now:", {
      data,
    });

    sendOutReportsEmails(data);
    // Add your distribute now logic here
  };

  const getReportsEmailSettings = useCallback(() => {
    let data = getBaseRequestData();
    const request = isWarehouseReport
      ? DistributionServices.getWarehouseReportsEmailSettings(data)
      : DistributionServices.getReportsEmailSettings(data);

    request
      .then((res) => {
        setloading(false);
        const recipients = normalizeListValue(res.recipientsEmails);
        const pdfStatusFilter = normalizeListValue(res.pdfStatusFilter);
        const viewValue = res.pdfLastUsedView || "Koncurent Standard View";
        const saveAs =
          !res.csvFormat && !res.pdfFormat
            ? null
            : res.csvFormat === "1"
            ? "csv"
            : "pdf";
        let freq = null;
        let weekDaysValue = null;
        let monthlyDayValue = null;

        // Detect Daily frequencies
        if (
          res.dayOfWeek === "Daily" ||
          res.dayOfWeek === "Daily-WeekDaysOnly"
        ) {
          freq = res.dayOfWeek;
        }
        // Detect Weekly
        else if (
          [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday",
          ].includes(res.dayOfWeek)
        ) {
          freq = "weekly";
          weekDaysValue = res.dayOfWeek;
        }
        // Detect Monthly
        else if (res.dayOfMonth) {
          freq = "monthly";
          monthlyDayValue = res.dayOfMonth;
        }

        const timeValue = res.hour || null;
        const timezoneValue = res.timeZone || null;
        const hasSavedSettings =
          recipients.length > 0 ||
          Boolean(saveAs) ||
          Boolean(freq) ||
          Boolean(weekDaysValue) ||
          Boolean(monthlyDayValue) ||
          Boolean(timeValue) ||
          Boolean(timezoneValue);

        setMode(
          isWarehouseReport
            ? hasSavedSettings
              ? "update"
              : "create"
            : res.recipientsEmails
            ? "update"
            : "create",
        );

        // Set current values
        setScheduleRecipients(recipients);
        setScheduleSaveAs(saveAs);
        setFrequency(freq);
        setWeekDays(weekDaysValue);
        setMonthlyDay(monthlyDayValue);
        setScheduleTime(timeValue);
        setTimezone(timezoneValue);
        setKoncurentStatus(pdfStatusFilter);
        setScheduleView(viewValue);

        // Store original values for comparison
        setOriginalScheduleData({
          recipients: [...recipients],
          koncurentStatus: [...pdfStatusFilter],
          view: viewValue,
          saveAs,
          frequency: freq,
          weekDays: weekDaysValue,
          monthlyDay: monthlyDayValue,
          time: timeValue,
          timezone: timezoneValue,
        });
      })
      .catch((err) => {
        setloading(false);
        setMode("create");
        resetScheduleDistribute();
        // Reset original data for create mode
        setOriginalScheduleData({
          recipients: [],
          koncurentStatus: [],
          saveAs: null,
          frequency: null,
          weekDays: [],
          monthlyDay: null,
          time: null,
          timezone: null,
        });

        // console.log(err);
      });
  }, [
    getBaseRequestData,
    isWarehouseReport,
    resetScheduleDistribute,
  ]);

  useEffect(() => {
    getReportsEmailSettings();
  }, [getReportsEmailSettings]);

  const deleteReportsEmailSettings = (data) => {
    const toastId = toast.loading("Deleting schedule distribution");
    const request = isWarehouseReport
      ? DistributionServices.deleteWarehouseReportsEmailSettings(data)
      : DistributionServices.deleteReportsEmailSettings(data);

    request
      .then((res) => {
        toast.success("Schedule distribution deleted successfully", {
          id: toastId,
        });
        getReportsEmailSettings();
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong, please try again.", {
          id: toastId,
        });
      });
  };

  const updateReportsEmailSettings = (data) => {
    const toastId = toast.loading("Updating schedule distribution");
    const request = isWarehouseReport
      ? DistributionServices.updateWarehouseReportsEmailSettings(data)
      : DistributionServices.updateReportsEmailSettings(data);

    request
      .then((res) => {
        toast.success("Schedule distribution updated successfully", {
          id: toastId,
        });
        // Update original data after successful update
        setOriginalScheduleData({
          recipients: [...scheduleRecipients],
          koncurentStatus: [...koncurentStatus],
          saveAs: scheduleSaveAs,
          frequency: frequency,
          weekDays: weekDays,
          monthlyDay: monthlyDay,
          time: scheduleTime,
          timezone: timezone,
          view: scheduleView,
        });
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong, please try again.", {
          id: toastId,
        });
      });
  };

  const createReportsEmailSettings = (data) => {
    const toastId = toast.loading("Creating schedule distribution");
    const request = isWarehouseReport
      ? DistributionServices.createWarehouseReportsEmailSettings(data)
      : DistributionServices.createReportsEmailSettings(data);

    request
      .then((res) => {
        toast.success("Schedule distribution created successfully", {
          id: toastId,
        });
        getReportsEmailSettings();
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong, please try again.", {
          id: toastId,
        });
      });
  };

  const handleScheduleDistribute = () => {
    let data = getBaseRequestData({
      csvFormat: scheduleSaveAs === "csv" ? "1" : "0",
      pdfFormat: scheduleSaveAs === "pdf" || isProcLog ? "1" : "0",
      recipientsEmails: scheduleRecipients.join(","),
      ...(!isWarehouseReport
        ? {
            pdfStatusFilter: koncurentStatus.join(","),
            pdfLastUsedView: scheduleView || "Koncurent Standard View",
          }
        : {}),
      dayOfWeek:
        frequency === "Daily" || frequency === "Daily-WeekDaysOnly"
          ? frequency
          : weekDays || "",
      dayOfMonth: monthlyDay || "",
      hour: scheduleTime,
      timeZone: timezone,
    });

    console.log("Schedule Distribute:", {
      data,
    });

    if (mode === "create") {
      createReportsEmailSettings(data);
    } else {
      updateReportsEmailSettings(data);
    }
  };

  const handleDeleteScheduleDistribute = () => {
    let data = getBaseRequestData();

    deleteReportsEmailSettings(data);
  };

  const tagsOptions = [
    { label: "Draft", value: "draft", color: "default" },
    { label: "Pending", value: "approaching", color: "orange" },
    { label: "Overdue", value: "overdue", color: "red" },
    { label: "Completed", value: "completed", color: "blue" },
  ];

  const tagRender = (props) => {
    const { label, value, closable, onClose } = props;
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    const tag = tagsOptions.find((tag) => tag.value === value);
    const color = tag?.color;

    return (
      <Tag
        color={color}
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
        style={{ marginInlineEnd: 4 }}
      >
        {label}
      </Tag>
    );
  };

  return (
    <>
      {isProcLog ? (
        <div
          onClick={!disabledButton ? showDrawer : null}
          className=" d-flex justify-content-left gap-2  align-items-center"
        >
          <FilePdfOutlined style={{ fontSize: "15px" }} />
          Distribute
        </div>
      ) : (
        <Button onClick={showDrawer} disabled={isLoading}>
          Distribute
        </Button>
      )}

      <Drawer
        title="Distribution"
        placement={"left"}
        onClose={onClose}
        open={open}
        key={"left"}
        width={400}
      >
        {/* Distribute Now Section */}
        <div>
          <div className=" d-flex justify-content-between">
            <strong className="fs-5">Distribute Now</strong>
            {hasDistributeNowData && (
              <Button type="text" onClick={resetDistributeNow}>
                Clear
              </Button>
            )}
          </div>

          <div style={{ marginTop: "1rem" }}>
            <label>
              <span>
                Recipients: <span style={{ color: "red" }}>*</span>
              </span>
            </label>
            <Select
              className="w-100"
              mode="multiple"
              placeholder="Start typing to search people"
              value={nowRecipients}
              onChange={setNowRecipients}
              options={userOptions}
              showSearch
              filterOption={(input, option) =>
                option.searchText.includes(input.toLowerCase())
              }
              style={{ marginTop: "0.5rem" }}
            />
          </div>

          {!isProcLog && (
            <div style={{ marginTop: "1rem" }}>
              <label>
                <span>
                  Send as: <span style={{ color: "red" }}>*</span>
                </span>
              </label>
              <Select
                className="w-100"
                placeholder="Select file type"
                value={nowSendAs}
                onChange={setNowSendAs}
                options={sendAsOptions}
                style={{ marginTop: "0.5rem" }}
              />
            </div>
          )}

          {isProcLog && (
            <>
              <div style={{ marginTop: "1rem" }}>
                <label>
                  <span>Status:</span>
                </label>
                <div>
                  <Select
                    mode="multiple"
                    value={nowStatusFilter}
                    onChange={setNowStatusFilter}
                    tagRender={tagRender}
                    style={{ width: "100%" }}
                    options={tagsOptions}
                  />
                </div>
              </div>

              <div style={{ marginTop: "1rem" }}>
                <label>
                  <span>View:</span> <span style={{ color: "red" }}>*</span>
                </label>
                <div>
                  <Select
                    showSearch
                    placeholder="Select a View"
                    className="w-100"
                    onChange={setNowView}
                    value={nowView}
                    options={SelectViewOptions}
                  />
                </div>
              </div>
            </>
          )}

          <div className=" mt-3">
            <small style={{ color: "red" }}>
              <i>* required field</i>
            </small>
          </div>
          <Button
            type="primary"
            onClick={handleDistributeNow}
            style={{ marginTop: "1rem", width: "100%" }}
            disabled={!nowRecipients.length || !nowSendAs || Loading}
          >
            Distribute Now
          </Button>
        </div>

        <hr style={{ margin: "2rem 0" }} />

        {/* Schedule Distribute Section */}
        <div>
          <div className=" d-flex justify-content-between">
            <strong className="fs-5">Schedule Distribution List</strong>
            {hasScheduleDistributeData && (
              <Button type="text" onClick={resetScheduleDistribute}>
                Clear
              </Button>
            )}
          </div>

          <div style={{ marginTop: "1rem" }}>
            <label>
              <span>
                Recipients: <span style={{ color: "red" }}>*</span>
              </span>
            </label>
            <Select
              className="w-100"
              mode="multiple"
              placeholder="Start typing to search people"
              value={scheduleRecipients}
              onChange={setScheduleRecipients}
              options={userOptions}
              showSearch
              filterOption={(input, option) =>
                option.searchText.includes(input.toLowerCase())
              }
              style={{ marginTop: "0.5rem" }}
            />
          </div>

          {!isProcLog && (
            <div style={{ marginTop: "1rem" }}>
              <label>
                <span>
                  Save as: <span style={{ color: "red" }}>*</span>
                </span>
              </label>
              <Select
                className="w-100"
                placeholder="Select file type"
                value={scheduleSaveAs}
                onChange={setScheduleSaveAs}
                options={sendAsOptions}
                style={{ marginTop: "0.5rem" }}
              />
            </div>
          )}

          <div style={{ marginTop: "1rem" }}>
            <label>
              <span>
                Frequency: <span style={{ color: "red" }}>*</span>
              </span>
            </label>
            <Select
              className="w-100"
              placeholder="Select frequency"
              value={frequency}
              onChange={handleFrequencyChange}
              options={frequencyOptions}
              style={{ marginTop: "0.5rem" }}
            />
          </div>

          {/* Weekly days selection */}
          {frequency === "weekly" && (
            <div style={{ marginTop: "1rem" }}>
              <label>
                <span>
                  Select a Day: <span style={{ color: "red" }}>*</span>
                </span>
              </label>
              <Select
                className="w-100"
                // mode="multiple"
                placeholder="Select days of the week"
                value={weekDays}
                onChange={setWeekDays}
                options={weekDayOptions}
                style={{ marginTop: "0.5rem" }}
              />
            </div>
          )}

          {/* Monthly day selection */}
          {frequency === "monthly" && (
            <div style={{ marginTop: "1rem" }}>
              <label>
                <span>
                  Day of Month: <span style={{ color: "red" }}>*</span>
                </span>
              </label>
              <Select
                className="w-100"
                placeholder="Select day of the month"
                value={monthlyDay}
                onChange={setMonthlyDay}
                options={monthlyDayOptions}
                style={{ marginTop: "0.5rem" }}
              />
            </div>
          )}

          {/* Time and Timezone Selection */}
          <div style={{ marginTop: "1rem" }}>
            <label>
              <span>
                Schedule Time: <span style={{ color: "red" }}>*</span>
              </span>
              <span className=" ms-4">
                Timezone: <span style={{ color: "red" }}>*</span>
              </span>
            </label>
            <div
              style={{ marginTop: "0.5rem" }}
              className=" d-flex justify-content-between"
            >
              <Select
                style={{ maxWidth: "200px" }}
                placeholder="Select time"
                value={scheduleTime}
                onChange={setScheduleTime}
                options={timeOptions}
              />
              <Select
                style={{ maxWidth: "220px", minWidth: "220px" }}
                placeholder="Select timezone"
                value={timezone}
                onChange={setTimezone}
                options={timezoneOptions}
                showSearch
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
                styles={{
                  popup: {
                    root: { width: 300 },
                  },
                }}
              />
            </div>
          </div>

          {isProcLog && (
            <>
              <div style={{ marginTop: "1rem" }}>
                <label>
                  <span>Status:</span>
                </label>
                <div>
                  <Select
                    mode="multiple"
                    value={koncurentStatus}
                    onChange={(values) => {
                      setKoncurentStatus(values);
                    }}
                    tagRender={tagRender}
                    style={{ width: "100%" }}
                    options={tagsOptions}
                  />
                </div>
              </div>

              <div style={{ marginTop: "1rem" }}>
                <label>
                  <span>View:</span> <span style={{ color: "red" }}>*</span>
                </label>
                <div>
                  <Select
                    showSearch
                    placeholder="Select a View"
                    className="w-100"
                    onChange={setScheduleView}
                    value={scheduleView}
                    options={SelectViewOptions}
                  />
                </div>
              </div>
            </>
          )}

          <div className=" mt-3">
            <small style={{ color: "red" }}>
              <i>* required field</i>
            </small>
          </div>

          <div className=" d-flex justify-content-between gap-2">
            {mode === "update" && (
              <Button
                type="primary"
                danger
                onClick={handleDeleteScheduleDistribute}
                style={{ marginTop: "1rem", width: "100%" }}
                disabled={Loading}
              >
                Delete Distribution
              </Button>
            )}
            <Button
              type="primary"
              onClick={handleScheduleDistribute}
              style={{ marginTop: "1rem", width: "100%" }}
              disabled={
                !scheduleRecipients.length ||
                (!isProcLog && !scheduleSaveAs) ||
                !frequency ||
                (frequency === "weekly" && !weekDays.length) ||
                (frequency === "monthly" && !monthlyDay) ||
                !scheduleTime ||
                !timezone ||
                Loading ||
                (mode === "update" && !hasScheduleChanges())
              }
            >
              {mode === "create" ? "Create" : "Update"}
            </Button>
          </div>
        </div>
      </Drawer>
    </>
  );
}

export default SidebarDistribution;
